import { set } from 'date-fns';
import { useSchedulerContext } from '@contexts/scheduler';
import { toTenantDate } from '@utils/timeZone';
import { WorkloadBasicForeman } from '@services/workload/calendar/types';
import { TimeRange } from '@components/scheduling/timeRangePicker/types';

export const useAssignForeman = () => {
  const { setState } = useSchedulerContext();

  return (foreman?: WorkloadBasicForeman, initial?: { day: Date; time: TimeRange }) =>
    setState((prev) => {
      const { schedule } = prev.active;
      const currentId = schedule.foreman?.id ?? '';
      const nextId = foreman?.id ?? '';
      if (!schedule.startsAt) {
        if (!initial) return prev;
        const at = (minutes: number) =>
          set(initial.day, {
            hours: Math.floor(minutes / 60),
            minutes: minutes % 60,
            seconds: 0,
            milliseconds: 0,
          });
        const [startsAt, endsAt] = [at(initial.time.start), at(initial.time.end)];
        return {
          ...prev,
          active: {
            ...prev.active,
            fresh: false,
            foremanId: nextId,
            newValues: { ...prev.active.newValues, foreman, startsAt, endsAt },
            schedule: {
              ...schedule,
              id: 'new',
              foreman: { ...schedule.foreman, ...foreman, id: nextId },
              startsAt: startsAt.toISOString(),
              endsAt: endsAt.toISOString(),
            },
          },
        };
      }
      if (currentId === nextId) return prev;
      return {
        ...prev,
        active: {
          ...prev.active,
          fresh: false,
          foremanChanged: true,
          mode: 'move',
          foremanId: nextId,
          newValues: {
            ...prev.active.newValues,
            foreman,
            startsAt: toTenantDate(schedule.startsAt),
            endsAt: toTenantDate(schedule.endsAt),
          },
          schedule: { ...schedule, foreman: { ...schedule.foreman, ...foreman, id: nextId } },
        },
      };
    });
};
